import { render, staticRenderFns } from "./AuthAlert.vue?vue&type=template&id=c951e332&"
import script from "./AuthAlert.vue?vue&type=script&lang=ts&"
export * from "./AuthAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports